module.exports = __webpack_public_path__ + "static/media/cross-royal.b82a4fbe.svg";